import * as React from "react";
import { observer, inject } from "mobx-react";
import { action, observable } from "mobx";
import { sort } from "../../../utils/data";
import SeekerStore from "../../../stores/seekerStore";
import { ILocalization } from "../../../models/localization";
import ProfileStore from "../../../stores/profileStore";
import { ProfileSkillState } from "../../../models/enums";
import { ProfileSkill } from "../../../models/profile";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui/Paper";
import FloatingAddBtn from "../../widgets/addBtn";
import * as s from "./skills.css";

@observer
export default class SkillSummary extends React.Component<{ store: SeekerStore }, {}> {

  constructor(props: any) {
    super(props);
  }

  showSkillGraph = (skill: ProfileSkill): void => {
    this.props.store.profileStore.setSelectedSkill(skill);
    this.props.store.profileStore.setSkillsViewMode(1);
  }

  showUpdateSkill = (skill: ProfileSkill): void => {
    this.props.store.profileStore.setSelectedSkill(skill);
    this.props.store.profileStore.setSkillsViewMode(0);
  }

  render(): JSX.Element {
    if (!this.props.store.profileStore.profile) {
      return null;
    }
    const skills: Array<ProfileSkill> = this.props.store.profileStore.profile.skills;
    const local: ILocalization = this.props.store.localization.fields;
    const skillRow: JSX.Element[] = [];
    sort(skills, "title").map((sk: ProfileSkill, i: number): void => {
      skillRow.push(
        <Row key={"skill-" + sk.idHash}>
          <Col xs={12}>
            <p onClick={() => this.showSkillGraph(sk)} className={s.skill}>{sk.title}</p><a onClick={() => this.showUpdateSkill(sk)} className={s.linkText}>&nbsp;&nbsp;&nbsp;{local.editCCLC.update.toLowerCase()}</a>
          </Col>
        </Row>);
    })

    if (skillRow.length === 0) {
      skillRow.push(<p key="no-skill-summary-list" className={s.smallText}>{local.profile.noSkills}</p>);
    }

    return (<Row>
      <Col xs={12}>
        {skillRow}     
      </Col>
      </Row>);
  }
}


// WEBPACK FOOTER //
// ./src/components/profile/skillSummary/index.tsx